"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalClose = exports.ModalBackdrop = exports.Modal = exports.ModalWrapper = exports.ModalContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _core = require("@emotion/core");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var modalAnimation = (0, _core.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n 0% { transform: translateY(20px); opacity: 0 }\n 100% { transform: translateY(0); opacity: 1 }\n"])));
var backdropAnimation = (0, _core.keyframes)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n 0% { opacity: 0 }\n 100% { opacity: 1 }\n"])));

var ModalContainer = _styled.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

exports.ModalContainer = ModalContainer;

var ModalWrapper = _styled.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  max-height: 100%;\n  position: relative;\n  overflow: auto;\n  padding: 20px;\n  width: 100%;\n  pointer-events: none;\n"])));

exports.ModalWrapper = ModalWrapper;

var Modal = _styled.default.div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  box-sizing: border-box;\n  position: relative;\n  pointer-events: all;\n  margin: 0 auto;\n  z-index: 1;\n  padding: 40px 20px 20px;\n  background: #fff;\n  width: 400px;\n  max-width: 100%;\n  border-radius: 5px;\n  min-height: 64px;\n  animation-name: ", ";\n  animation-duration: 400ms;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n"])), modalAnimation);

exports.Modal = Modal;

var ModalBackdrop = _styled.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.25);\n  animation-name: ", ";\n  animation-duration: 400ms;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n"])), backdropAnimation);

exports.ModalBackdrop = ModalBackdrop;

var ModalClose = _styled.default.button(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  appearance: none;\n  border: none;\n  padding: 0;\n  background: transparent;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  cursor: pointer;\n\n  &:active {\n    opacity: 0.5;\n  }\n"])));

exports.ModalClose = ModalClose;